// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
import $ from 'jquery';
// eslint-disable-next-line import/no-unresolved
// import 'channels';

import 'jquery';
import 'popper.js';
import 'bootstrap';
import '@hotwired/turbo-rails';
import './show_password';
import '../controllers';

Turbo.session.drive = false;
// import Sortable from "sortablejs";

require('@rails/ujs').start();
// require('turbolinks').start();
require('@rails/activestorage').start();

// Cherrypick extra plugins
// import Sortable, { MultiDrag, Swap } from "sortablejs";

// Cherrypick default plugins
// import Sortable, { AutoScroll } from "sortablejs/modular/sortable.core.esm.js";

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

global.$ = jQuery;

// showToast removido: buscava /attachments.json?pending='true' e escrevia
// `attachments.length` no #toast-text. O endpoint e paginado (pagy limit 25),
// entao o numero maximo possivel era 25 -- o real e 341.261 (status IS NULL).
// As tres views que tem #toast-text ja renderizam @pending_docs no servidor.
// A funcao tambem estava morta (nenhum chamador) e o toast de verdade vem de
// app/javascript/toast.js, usado pelo radar_app_notification_channel.

function watchImports() {
  const $id = $('#page-function-id');

  if ($id.length > 0) {
    const fileName = $id.val();
    switch (fileName) {
      case 'commercial-routes-form':
        import('../views/commercial_routes/form');
        break;
      case 'commercial-routes-index':
        import('../views/commercial_routes/index');
        break;
    }
  }
}

function checkAlerts() {
  if ($('.status-alert').is(':visible')) {
    setTimeout(function () {
      $('.status-alert').alert('close');
    }, 3000);
  }
}

function updateBitremSelection() {
  const radios = $('.bitrem-radio');
  radios.each(function updateBitremRadio() {
    const card = $(this).closest('.bitrem-card');
    const header = card.find('.card-header');

    if ($(this).is(':checked')) {
      card.addClass('border-success');
      header.removeClass('bg-light');
      header.addClass('bg-success');
    } else {
      card.removeClass('border-success');
      header.addClass('bg-light');
      header.removeClass('bg-success');
    }
  });
}

function copyToClipboard() {
  $(document).on('click', '.copy-icon', function () {
    const $el = $(this);
    const target = $el.data('target');
    const text = $(target).text().trim();

    navigator.clipboard.writeText(text).then(() => {
      $el.attr('data-original-title', 'Copiado!').tooltip('show');

      setTimeout(() => {
        $el.tooltip('hide');
      }, 2000);
    });
  });
}

$(() => {
  copyToClipboard()
  $(window).on('shown.bs.modal', function () {
    $('[data-toggle="tooltip"]').tooltip();

    $('.bitrem-card').on('click', function () {
      $(this).find('.bitrem-radio').prop('checked', true).trigger('change');
      updateBitremSelection();
    });
  });

  $('[data-toggle="tooltip"]').tooltip();
  checkAlerts();
  watchImports();
  $('.dropdown-menu a.dropdown-toggle').on('click', function (e) {
    if (!$(this).next().hasClass('show')) {
      $(this)
        .parents('.dropdown-menu')
        .first()
        .find('.show')
        .removeClass('show');
    }
    const $subMenu = $(this).next('.dropdown-menu');
    $subMenu.toggleClass('show');

    $(this)
      .parents('li.nav-item.dropdown.show')
      .on('hidden.bs.dropdown', function (e) {
        $('.dropdown-submenu .show').removeClass('show');
      });

    return false;
  });
});
